import React from 'react';
import PropTypes from 'prop-types';

export const GifGridItem = ( {id, title, url} ) => {

    
  return (
  <div className="card animate__animated animate__fadeIn">
      <img src={url} id={id} alt={title} />
        <p>{title}</p>
  </div>
  );
};

GifGridItem.propTypes ={
  title: PropTypes.string.isRequired,
  url: PropTypes.string.isRequired,
}